(() => {
  const __shopifySectionId=document.currentScript?.dataset.sectionId||'';
  if (window.__yurchakShippingRulesV5) return;
  window.__yurchakShippingRulesV5 = true;
  const marker = document.querySelector('[data-yurchak-shipping-rules]');
  if (!marker) return;
  const country = String(marker.dataset.country || '').toUpperCase();
  const marketCurrency = String(marker.dataset.currency || 'USD').toUpperCase();
  const normalize = value => String(value || marketCurrency || 'USD').toUpperCase();
  const renderedShippingThreshold = Number(marker.dataset.shippingThreshold || 0);
  const rateFor = currency => window.YurchakCartCore?.rateFor ? Number(window.YurchakCartCore.rateFor(normalize(currency))) || 1 : 1;
  const usdThreshold = (amount,currency) => window.YurchakCartCore?.thresholdCents ? Number(window.YurchakCartCore.thresholdCents(amount,normalize(currency))) || 0 : 0;
  const shippingThreshold = currency => window.YurchakCartCore?.shippingThresholdCents
    ? Number(window.YurchakCartCore.shippingThresholdCents(160,normalize(currency),country)) || 0
    : renderedShippingThreshold;
  const format = (cents,currency) => {
    currency = normalize(currency);
    if (window.YurchakMoney?.format) return window.YurchakMoney.format(cents,currency);
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en',{style:'currency',currency,currencyDisplay:'narrowSymbol',minimumFractionDigits:0,maximumFractionDigits:0}).format(Number(cents || 0)/100); }
    catch (_) { return `${Math.round(Number(cents || 0)/100)} ${currency}`; }
  };
  window.YurchakShippingRules = Object.freeze({country,marketCurrency,shippingThreshold,usdThreshold,format});
})();
